<template>
  <div :class="$style.slideContent">
    <div :class="$style.groupKey">
      {{ group?.monthName }}
    </div>

    <ul
      v-if="group?.eventItems?.length"
      :class="$style.group"
    >
      <li
        v-for="entry in group?.eventItems"
        :key="`event-${entry?.id}`"
        :class="$style.item"
      >
        <SharedEventsLinkComponent
          :data="entry"
          :class="$style.thumbnail"
        >
          <SharedEventsThumbnailComponent :data="entry" />
        </SharedEventsLinkComponent>
      </li>
    </ul>

    <ul
      v-if="group?.exhibitionItems?.length"
      :class="$style.group"
    >
      <li :class="$style.groupLabel">
        {{ $t('pages.events.exhibitions.label', group?.exhibitionItems?.length) }}
      </li>
      <li
        v-for="entry in group?.exhibitionItems"
        :key="`event-${entry?.id}`"
        :class="$style.item"
      >
        <SharedExhibitionsLinkComponent
          :data="entry"
          :class="$style.thumbnail"
        >
          <SharedExhibitionsLinkThumbnailComponent :data="entry" />
        </SharedExhibitionsLinkComponent>
      </li>
    </ul>
  </div>
</template>

<script setup>
const props = defineProps({
  group: {
    type: Object,
    required: true
  }
})
</script>


<style module>
  .slideContent {
    composes: container--100vw--background from global;
  }

  .groupKey {
    composes: font-size-x-large from global;
    /* text-transform: uppercase; */
    border-bottom: var(--stroke--default) solid;
  }

  .group {
    composes: reset-list from global;
  }

  .item {
  }

  .thumbnail {
    display: block;

    border-bottom: var(--stroke--default) solid var(--color--primary);
    padding: calc(var(--unit--default) / 2) 0;
  }

  .thumbnail[class*='router-link-exact-active'] {
    color: var(--color--gray);
    pointer-events: none;
  }
</style>
